import type { RecordType } from '@factorialco/f0-react/dist/experimental'

import type { Document } from 'modules/documents/hooks/documents/useGetDocuments'

/**
 * Adapts DataCollection records (typed as generic RecordType) to Document[].
 *
 * The f0-react DataCollection framework uses `RecordType = Record<string, unknown>`
 * as its generic constraint, but the actual runtime data matches our Document interface.
 * This adapter centralizes the type bridge between the two systems.
 */
export function asDocuments(records: RecordType[] | undefined): Document[] {
  // eslint-disable-next-line no-type-assertion/no-type-assertion -- centralised type bridge between DataCollection RecordType and Document
  return (records ?? []) as unknown as Document[]
}
